import type { ModuleNav } from '@saas/ui';

export const MEETING_READ = ['meeting-ingest.meeting.read', 'meeting-ingest.meeting.write', 'meeting-ingest.meeting.manage'];
export const MEETING_WRITE = ['meeting-ingest.meeting.write', 'meeting-ingest.meeting.manage'];
export const MEETING_SETTINGS = ['meeting-ingest.integration.manage', 'meeting-ingest.keyword.manage'];

/** meeting-ingest のメニュー（03 §13）。管理は外部会議連携・キーワード・録画の保存期間 */
export const meetingIngestNav: ModuleNav = {
  module: 'meeting-ingest',
  items: [
    { label: '会議', to: '/meeting-ingest', icon: 'group', end: true, permission: MEETING_READ, description: '録画・文字起こし・要約・決定事項' },
    { label: 'PCで録音', to: '/meeting-ingest/record/new', icon: 'mic', permission: MEETING_WRITE, description: '対面・他の会議ツールの音声から議事録を作る' },
    { label: '録画を取り込む', to: '/meeting-ingest/upload', icon: 'upload', permission: MEETING_WRITE, description: 'Zoom / Teams / Meet の録画ファイル' },
    { label: '決定事項', to: '/meeting-ingest/decisions', icon: 'check_circle', permission: MEETING_READ, description: '顧客・案件をまたいだ履歴' },
    { label: '宿題', to: '/meeting-ingest/action-items', icon: 'assignment', permission: MEETING_READ, description: '未完了のアクションアイテム' },
  ],
  admin: [{ label: '会議設定', to: '/meeting-ingest/settings', icon: 'settings', permission: MEETING_SETTINGS, description: 'オンライン会議・録画取込・保存期間' }],
};
